<nav>
  <div class="navbar-wrapper">
    <div class="m-header">
      <a (click)="returnHome()" class="b-brand">
        @if (themeMode === 'compact') {
          <img src="assets/images/natfood-logo.svg" style="
          width: 150px;
      " alt="small-menu-logo" class="logo logo-sm" />
        } @else {
          <img src="assets/images/natfood-logo.svg" style="
          width: 150px;
      " alt="logo" class="logo logo-lg" />
        }
      </a>
    </div>
    <app-nav-content
      (NavCollapsedMob)="navCollapseMob()"
      (SubmenuCollapse)="navSubmenuCollapse()"
      class="scroll-div w-100 compact"
    ></app-nav-content>
  </div>
</nav>
